<template>
<div class="bind">
	<div class="van-nav-bar van-hairline--bottom">
		<div class="van-nav-bar__content">
			<div class="van-nav-bar__left van-haptics-feedback"  @click="back()">
				<i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
			</div>
			<div class="van-nav-bar__title van-ellipsis">
				{{$t('common.setbank')}}
			</div>
		</div>
	</div>
	<div class="add-card" @click="toBindCard()" v-if="!is_bind">
		<van-icon name="plus" size="1.2rem" />
		<span>{{$t('common.addbank')}}</span>
	</div>
	<div class="bank" v-else>
		<div class="bank-info">
			<div class="bank-item" v-if="parsedBankInfo.bank_name">
				<label>银行名称：</label>
				<span>{{parsedBankInfo.bank_name}}</span>
			</div>
			<div class="bank-item" v-if="parsedBankInfo.branch_name">
				<label>支店名称：</label>
				<span>{{parsedBankInfo.branch_name}}</span>
			</div>
			<div class="bank-item" v-if="parsedBankInfo.branch_number">
				<label>支店番号：</label>
				<span>{{parsedBankInfo.branch_number}}</span>
			</div>
			<div class="bank-item" v-if="parsedBankInfo.account_type">
				<label>账户类型：</label>
				<span>{{parsedBankInfo.account_type}}</span>
			</div>
			<div class="bank-item" v-if="parsedBankInfo.account_number">
				<label>口座番号：</label>
				<span>{{parsedBankInfo.account_number}}</span>
			</div>
			<div class="bank-item" v-if="parsedBankInfo.katakana">
				<label>カタカナ：</label>
				<span>{{parsedBankInfo.katakana}}</span>
			</div>
		</div>
		<div class="bank-name" v-if="this.bankInfo.bankname">
			{{this.bankInfo.bankname}}
		</div>
	</div>
</div>

</template>

<script>
export default {
  data() {
    return {
      is_bind:false,
      bankInfo:{},
      userInfo:{},
      formattedBankInfo: '', // 格式化后的银行信息
      parsedBankInfo: {} // 解析后的银行信息对象
    };
  },
  computed: {
    // 解析并格式化银行信息
    displayBankInfo() {
      if(!this.bankInfo || !this.bankInfo.bankinfo) {
        console.log('displayBankInfo: bankInfo 或 bankinfo 为空');
        return '';
      }
      
      // 优先使用后端格式化好的字段
      if(this.bankInfo.bankinfo_formatted && this.bankInfo.bankinfo_formatted.trim()) {
        console.log('使用后端格式化字段:', this.bankInfo.bankinfo_formatted);
        return this.bankInfo.bankinfo_formatted;
      }
      
      const bankinfoStr = String(this.bankInfo.bankinfo || '').trim();
      console.log('原始 bankinfo 字符串:', bankinfoStr);
      
      // 如果为空，返回空字符串
      if(!bankinfoStr) {
        console.log('bankinfo 字符串为空');
        return '';
      }
      
      // 如果已经是普通字符串（不是JSON），直接返回
      const trimmedStr = bankinfoStr.trim();
      if(!trimmedStr.startsWith('{') && !trimmedStr.startsWith('[')) {
        console.log('不是 JSON 格式，直接返回:', bankinfoStr);
        return bankinfoStr;
      }
      
      try {
        // 尝试解析 JSON
        let bankInfoJson = null;
        try {
          bankInfoJson = JSON.parse(bankinfoStr);
          console.log('JSON 解析成功:', bankInfoJson);
        } catch(e) {
          console.warn('第一次 JSON 解析失败:', e);
          // 如果解析失败，尝试修复常见的 JSON 格式问题
          let fixedStr = bankinfoStr;
          // 移除控制字符
          // eslint-disable-next-line no-control-regex
          fixedStr = fixedStr.replace(/[\u0000-\u001F]/g, '');
          // 尝试修复不完整的 JSON（如果被截断）
          if(fixedStr.endsWith(',') || (!fixedStr.endsWith('}') && !fixedStr.endsWith(']'))) {
            // 如果 JSON 不完整，尝试补全
            if(fixedStr.startsWith('{') && !fixedStr.endsWith('}')) {
              fixedStr = fixedStr + '}';
            } else if(fixedStr.startsWith('[') && !fixedStr.endsWith(']')) {
              fixedStr = fixedStr + ']';
            }
          }
          try {
            bankInfoJson = JSON.parse(fixedStr);
            console.log('修复后 JSON 解析成功:', bankInfoJson);
          } catch(e2) {
            console.error('修复后 JSON 解析仍然失败:', e2, '原始字符串:', bankinfoStr);
            return bankinfoStr;
          }
        }
        
        if(bankInfoJson && typeof bankInfoJson === 'object') {
          if(Array.isArray(bankInfoJson)) {
            // 如果是数组格式，使用第一个元素
            if(bankInfoJson.length > 0 && typeof bankInfoJson[0] === 'object') {
              bankInfoJson = bankInfoJson[0];
            } else {
              console.log('数组格式但无有效元素');
              return bankinfoStr;
            }
          }
          
          // 格式化显示：银行名称 支店名称 账户类型
          const parts = [];
          if(bankInfoJson.bank_name) parts.push(String(bankInfoJson.bank_name).trim());
          if(bankInfoJson.branch_name) parts.push(String(bankInfoJson.branch_name).trim());
          if(bankInfoJson.account_type) parts.push(String(bankInfoJson.account_type).trim());
          
          const result = parts.filter(p => p && p.length > 0).join(' ');
          console.log('格式化结果:', result, 'parts:', parts);
          // 如果格式化后为空，返回原值
          if(result && result.trim()) {
            return result;
          } else {
            console.warn('格式化后为空，返回原值');
            return bankinfoStr;
          }
        } else {
          console.log('bankInfoJson 不是对象类型:', typeof bankInfoJson);
        }
      } catch(e) {
        console.error('解析银行信息异常:', e, bankinfoStr);
        return bankinfoStr;
      }
      
      console.log('最终返回原值:', bankinfoStr);
      return bankinfoStr;
    }
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.bankInfo = res.data.info;
            // 立即格式化银行信息
            this.formatBankInfo();
            // 调试：打印银行信息
            console.log('银行信息原始数据:', this.bankInfo);
            console.log('bankinfo字段:', this.bankInfo.bankinfo);
            console.log('格式化后:', this.formattedBankInfo);
          }else {
            this.is_bind = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    formatBankInfo(){
      if(!this.bankInfo || !this.bankInfo.bankinfo) {
        this.formattedBankInfo = '';
        this.parsedBankInfo = {};
        return;
      }
      
      const bankinfoStr = String(this.bankInfo.bankinfo || '').trim();
      
      if(!bankinfoStr) {
        this.formattedBankInfo = '';
        this.parsedBankInfo = {};
        return;
      }
      
      // 如果已经是普通字符串（不是JSON），直接使用
      const trimmedStr = bankinfoStr.trim();
      if(!trimmedStr.startsWith('{') && !trimmedStr.startsWith('[')) {
        this.formattedBankInfo = bankinfoStr;
        this.parsedBankInfo = {};
        return;
      }
      
      try {
        // 尝试解析 JSON
        let bankInfoJson = null;
        try {
          bankInfoJson = JSON.parse(bankinfoStr);
        } catch(e) {
          // 如果解析失败，尝试修复常见的 JSON 格式问题
          // eslint-disable-next-line no-control-regex
          let fixedStr = bankinfoStr.replace(/[\u0000-\u001F]/g, '');
          if(fixedStr.startsWith('{') && !fixedStr.endsWith('}')) {
            fixedStr = fixedStr + '}';
          }
          try {
            bankInfoJson = JSON.parse(fixedStr);
          } catch(e2) {
            console.error('解析银行信息失败:', e2, bankinfoStr);
            this.formattedBankInfo = bankinfoStr;
            this.parsedBankInfo = {};
            return;
          }
        }
        
        if(bankInfoJson && typeof bankInfoJson === 'object') {
          let data = bankInfoJson;
          if(Array.isArray(bankInfoJson) && bankInfoJson.length > 0) {
            data = bankInfoJson[0];
          }
          
          // 保存解析后的完整信息
          this.parsedBankInfo = {
            bank_name: data.bank_name || '',
            branch_name: data.branch_name || '',
            branch_number: data.branch_number || '',
            account_type: data.account_type || '',
            account_number: data.account_number || '',
            katakana: data.katakana || ''
          };
          
          // 格式化显示：银行名称 支店名称 账户类型（用于兼容旧代码）
          const parts = [];
          if(data.bank_name) parts.push(String(data.bank_name).trim());
          if(data.branch_name) parts.push(String(data.branch_name).trim());
          if(data.account_type) parts.push(String(data.account_type).trim());
          
          const result = parts.filter(p => p && p.length > 0).join(' ');
          this.formattedBankInfo = result || bankinfoStr;
        } else {
          this.formattedBankInfo = bankinfoStr;
          this.parsedBankInfo = {};
        }
      } catch(e) {
        console.error('解析银行信息异常:', e, bankinfoStr);
        this.formattedBankInfo = bankinfoStr;
        this.parsedBankInfo = {};
      }
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    toBindCard() {
      this.$router.push({path:'/BindCard'})
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
:export {
    gbcolor: linear-gradient(30deg,#7d76ef,#d63f8c)
}
.van-nav-bar {
    z-index: 999;
	position: relative;
    background: url(/img/header.svg) no-repeat 50%/100%;
}
.van-nav-bar__content{
	height:3rem;
}
.bind {
    width: 100%;
    height: 100%;
    background: #f0f0f0
}

.bind .van-field__control::-webkit-input-placeholder {
    text-overflow: ellipsis;
    white-space: normal;
    overflow: hidden
}

.bind .van-field__control::-moz-placeholder {
    text-overflow: ellipsis;
    white-space: normal;
    overflow: hidden
}

.bind .van-field__control:-ms-input-placeholder {
    text-overflow: ellipsis;
    white-space: normal;
    overflow: hidden
}

.bind .btn {
    width: 100%;
    padding: 10%;
    display: flex;
    justify-content: center;
    align-items: center
}

.bind .btn a {
    width: 100%;
    background: linear-gradient(90deg,#f560cd,#4f2b8a);
    color: #fff;
    padding: .66667rem 0;
    border-radius: .33333rem
}

.bind .bank {
    width: 90%;
    min-height: 10rem;
    background: #705b65;
    border-radius: .66667rem;
    margin: 1rem auto;
    text-align: left;
    padding: 5%;
    position: relative;
    overflow: hidden
}
.bind .add-card{
	width: 90%;
	height: 10rem;
	background: #705b65;
	border-radius: .66667rem;
	text-align: center;
	padding: 14%;
	position: relative;
	margin: 1rem auto;
	font-size: 1.5rem;
	color: #fff;
}

.bind .bank .bank-info {
    position: relative;
    z-index: 9;
    padding-bottom: 1rem;
}

.bind .bank .bank-item {
    color: #ede7e7;
    padding: .2rem 0;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
}

.bind .bank .bank-item label {
    color: #dfbb9e;
    min-width: 5rem;
    display: inline-block;
    font-weight: normal;
}

.bind .bank .bank-item span {
    color: #fff;
    flex: 1;
    word-break: break-all;
}

.bind .bank .bank-name {
    position: absolute;
    right: .66667rem;
    bottom: .66667rem;
    color: #dfbb9e;
    z-index: 9;
    font-size: 0.9rem;
}

.bind .bank i {
    position: absolute;
    right: -3.33333rem;
    top: 0;
    color: #877f7e;
    font-size: 10rem;
    opacity: .4
}

.bind .van-cell__value {
    justify-content: space-between;
    align-items: center;
    display: flex
}

.bind .van-cell__value .van-field__body {
    width: 100%
}

.bind .van-cell__value .van-dropdown-menu__bar {
    height: auto;
    box-shadow: none
}

.bind .van-cell__value .van-dropdown-menu__bar .van-dropdown-menu__item {
    justify-content: flex-start
}

.bind .van-cell__value .van-dropdown-menu__title {
    padding-left: 0
}

</style>
